module.exports = __webpack_public_path__ + "img/icon-resv.a495015c.svg";